import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent implements OnInit {

  itemArray : AbstractItem[];
  websiteArray : AbstractWebsite[];
  techArray : string[];

  constructor() { }

  ngOnInit() {

    //web apps
    this.itemArray = [{  'img_main' : 'work5.png',
                             'title' : 'Personal File Manager for Gvt officers',
                             'img_list' : ['work5.png', 'work51.png', 'work52.png'],
                             'details_list':['Home page contains the routes for main functions in a establishment branch.',
                                             'Font Awesome icons improves the UI user friendliness',
                                             'Responsive & cross browser compatible UI implementation',
                                             'Bootstrap CSS library in-build css classes, js functions supports',
                                             'Generate list of printable reports without alignment issues & third party libraries',
                                             'All these reports are easily customizable and extendable for client requirements'],
                             'technologies': ['Php 7.4.26', 'CodeIgniter 3.1.11','Apache 2.4.51','MySQL 5.7.36',
                                           'Bootstrap v4.1.1', 'Font Awesome Free 5.13.1'],
                             'last_updated': '2021'},

      					      {'img_main' : 'work4.png',
                             'title' : 'Web app for employee Leave management',
                             'img_list' : ['work4.png', 'work41.png', 'work42.png'],
                             'details_list':['Landing page after login route displays the summery of user assigned leaves',
                                             'Simple JS carousel builds the user friendly and modern UI',
                                             'History page taken leaves with status and filter by leave type',
                                             'Responsive UI improves the accessibility from different devices',
                                             'Has two user authorization levels ',
                                             'One user can apply for leave and his/her supervisor gives the feedback'],
                             'technologies': ['Php 7.4.26', 'CodeIgniter 3.1.11','Apache 2.4.51','MySQL 5.7.36',
                                         'Bootstrap v4.1.1', 'Font Awesome Free 5.13.1'],
                             'last_updated': '2021'},

                      {'img_main' : 'work6.png',
                             'title' : 'In-store food ordering app for a restaurant',
                             'img_list' : ['work6.png', 'work61.png', 'work62.png'],
                             'details_list':['User friendly menu page with basic details of each food item',
                                             'Important to display high quality images to attract the customers',
                                             'Only admin(ex. Manager) has authorized to see these details',
                                             'Manager can improve the productivity and performance of processing food using these data',
                                             'This is the details of a order from waiter/chef perspective while processing the food',
                                             'He can shift the status of order using the button and display the processing time spend for each stage'],
                             'technologies': ['Php 7.4.26', 'CodeIgniter 3.1.11','Apache 2.4.51','MySQL 5.7.36',
                                        'Bootstrap v4.1.1', 'Font Awesome Free 5.13.1'],
                             'last_updated': '2022'},

                       {'img_main' : 'work9.png',
                              'title' : 'Minesweeper Puzzle game',
                              'img_list' : ['work9.png', 'work91.png', 'work92.png'],
                              'details_list':['Traditional Minesweeper game board that came with windows early versions ',
                                              'Follows the best practices of design and implementation for javaFx apps ',
                                              'Allows to change the UI theme at any stage',
                                              'Appearance change feature is extendable with low cost to meet modern requirements',
                                              'Has three levels based on size of the board, easy for modifications',
                                              'number in a grid is the sum of mines which located in surrounding 9 grids'],
                              'technologies': ['java 8', 'swing','javafx 1.8'],
                              'last_updated': '2014'},

                       {'img_main' : 'work8.png',
                              'title' : 'Matching three board game',
                              'img_list' : ['work8.png', 'work81.png', 'work82.png'],
                              'details_list':['Basic tile color matching board game ',
                                              'Follows the best practices of design and implementation for javaFx apps',
                                              'Use simple csv file for saving the score records',
                                              'Simple integer arrays and for loops of java implements the game logic',
                                              'user friendly UI generated by javaFx builder',
                                              'Low cost extendability of the code allows adding more complex features'],
                              'technologies': ['java 8', 'swing','javafx 1.8'],
                              'last_updated': '2014'},

                       {'img_main' : 'work10.png',
                              'title' : 'Sudoku Puzzle game',
                              'img_list' : ['work10.png', 'work101.PNG', 'work102.PNG'],
                              'details_list':['Famous sudoku puzzle game',
                                              'Follows the best practices of design and implementation for javaFx apps',
                                              'Extendable game levels based on size and complexity',
                                              'Simple integer arrays and for optimized loops in java does the work nicely',
                                              'Save the scores to see your progress',
                                              'user friendly UI generated by javaFx builder'],
                              'technologies': ['java 8', 'swing','javafx 1.8'],
                              'last_updated': '2014'},
                       {'img_main' : 'work12.PNG',
                               'title' : 'Merge Story',
                               'img_list' : ['work123.PNG', 'work121.PNG', 'work122.PNG'],
                               'details_list':['A simple Java Script version for merge games collection',
                                               'Light Weight source code written only using html, css and java script',
                                               'A board game with simple logic for players to have fun in small free times',
                                               'two types of icons, as icon generators and basic icons',
                                               'Basic icon selling is the main source of game level up',
                                               'Icon orders will appear in random beside the game board.'],
                               'technologies': ['html5', 'css3','javascript', 'bootstrap5'],
                               'last_updated': '2024'}
                       ];

        //websites
        this.websiteArray = [{'img_main' : 'work71.PNG',
                          'title' : 'Static responsive website for small business.',
                          'link' : 'https://kaushi-stores.w3spaces.com'},

                        {'img_main' : 'work3.png',
                          'title' : 'My personal tech blog',
                          'link' : 'https://piyumi11.github.io'}];

        //tech stack
        this.techArray = ['java', 'php', 'codeigniter', 'spring', 'angular', 'python',
                           'html', 'css', 'javascript', 'bootstrap', 'jquery', 'javafx',
                           'mysql', 'oracledb', 'mongodb', 'hibernate', 'innodb', 'mysql',
                           'http', 'tomcat', 'lamp', 'xampp', 'glassfish', 'nodejs',
                           'git', 'npm', 'gradle', 'Jenkins', 'Maven', 'docker',
                           'uml', 'junit', 'jusmine', 'tcpdf', 'jmeter', 'opengl'];
  }
}

export interface AbstractItem {
    img_main: string,
    title: string,
    img_list: string[],
    details_list: string[],
    technologies: string[],
    last_updated: string
}

export interface AbstractWebsite {
    img_main: string,
    title: string,
    link: string
}
